import Box, { BoxProps } from '@mui/material/Box'

import TiktokSvg from '@shared/assets/images/icons/icon-tiktok.svg?react'

export const TiktokIcon = (props: BoxProps) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Box {...props}>
    <TiktokSvg />
  </Box>
)

export default TiktokIcon
